import styled from 'styled-components'

import { style } from 'theme'

export const Page = styled.div`
  width: 100%;
  max-width: 800px;
  min-height: 400px;
  margin: 0px auto;
  display: flex;
  flex-direction: column;
  align-items: center;
  border-radius: ${style(theme => theme.borderRadius.large)};
`
